module.exports = __webpack_public_path__ + "static/media/hurricane.71fbe2ff.usdz";